/**
 * Birth date utilities for the Champion application form.
 * The form stores dates as "Mar 5, 2026" (from BirthDateField calendar) or "MM/DD/YYYY".
 * Uses local date components to avoid timezone shift.
 */

/** Parse form's birth date string to Date using local time. Returns null if empty or invalid. */
export function parseBirthDateToLocal(value: string): Date | null {
  if (!value?.trim()) return null;
  const trimmed = value.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const [y, m, d] = trimmed.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const date = new Date(trimmed);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Convert birthDate to ISO format (YYYY-MM-DD) for API payload. Uses local date components. */
export function toISOBirthDate(value: string): string {
  if (!value || !value.trim()) return value;
  const trimmed = value.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
  const date = parseBirthDateToLocal(trimmed);
  if (!date) return value;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
